<div class="flex flex-row gap-2">
  <div class="flex flex-col">
    <div class="flex flex-row text-xs">
      @for (shortcut of shortcuts(); track shortcut; let i = $index) {
        <div
          class="flex flex-col justify-center items-center hover:underline cursor-pointer md:px-3 px-2"
          (click)="shortcutClick.emit(shortcut.query)"
          [class]="i === shortcuts().length - 1 ? 'border-r-0' : 'border-r'"
        >
          <soft-icon [name]="shortcut.icon" class="fa-xl"></soft-icon>
          <div class="w-full text-center pt-1 text-xs md:text-sm">
            {{ shortcut.title | translate }}
          </div>
        </div>
      }
    </div>
  </div>
</div>
